module.exports = __webpack_public_path__ + "static/media/reports.234f1d4e.svg";